import { useCallback, useEffect } from 'react';
import useInterval from '@alltrails/core/hooks/useInterval';
import { millisecondsInDay, millisecondsInMinute, millisecondsInSecond } from '@alltrails/data-formatting/dateConstants';
import { updatePreloadedOverlayUTCs, updateSelectedUTC } from '../redux/conditionsSlice';
import { useAppDispatch, useAppSelector } from '../redux/helpers';

const useIntervalDelayMs = Math.round(millisecondsInSecond / 3); // 3 fps

const getDayUTCs = (intervalMs: number, dayStartUTC: number) => {
  return Array(millisecondsInDay / intervalMs)
    .fill(0)
    .map((_, i) => dayStartUTC + i * intervalMs);
};

const useConditionPlayback = (intervalMinutes: number, dayStartUTC?: number) => {
  const dispatch = useAppDispatch();
  const { isPlayingOverlay, selectedUTC } = useAppSelector(state => ({
    isPlayingOverlay: state.conditions.isPlayingOverlay,
    selectedUTC: state.conditions.selectedUTC
  }));

  const utcIncrementMs = millisecondsInMinute * intervalMinutes;

  useEffect(() => {
    if (dayStartUTC && isPlayingOverlay) {
      dispatch(updatePreloadedOverlayUTCs(getDayUTCs(utcIncrementMs, dayStartUTC)));
    }
  }, [dayStartUTC, dispatch, isPlayingOverlay, utcIncrementMs]);

  const updateUTC = useCallback(() => {
    if (selectedUTC && dayStartUTC) {
      // If the utc update would push us to a new day, wrap back around to the start of the day
      const newUTC = ((selectedUTC + utcIncrementMs - dayStartUTC) % millisecondsInDay) + dayStartUTC;
      dispatch(updateSelectedUTC(newUTC));
    }
  }, [dayStartUTC, dispatch, selectedUTC, utcIncrementMs]);

  useInterval(updateUTC, isPlayingOverlay ? useIntervalDelayMs : null);
};

export default useConditionPlayback;
